export default "__VITE_ASSET__1d7e6e59__"